import { useAuthContext } from "../../../contexts/auth-context";
import { ASSETS_ROUTES, DEVICES_SIZES_IN_PX } from "../../../lib/common/constants";
import { useRouteNavigation } from "../../../lib/common/routes";
import { RouteEnumType } from "../../../lib/types/routes";
import { DashboardLink, MyAccountLink, MyHomeLink } from "../../common/header";
import { SignInAndOut } from "../../common/user-signin-modal";
import { evaluators, useWindowSizeMatch } from "../../../lib/window-size-matcher";
import { NotificationsV2 } from "../../common/notifications-v2";
import { SupportBtn } from "../../common/supportbutton";
import { MessagesNotifications } from "../../common/mobile-messages-notifications";
import { CSSProperties } from "react";
import { useUserService } from "../../../services/users";

export const topMenuNotificationsNumberStyle: CSSProperties = {
    position: "absolute",
    right: "0.1rem",
    top: "0.15rem",
};

export const TopMenu = ({ isLandingPage = false }: { isLandingPage?: boolean }) => {
    const { userInfo, isLoggedIn } = useAuthContext();
    const { refreshSuprSendUserToken } = useUserService();
    const { navigateRouteClickHandler, getRoute } = useRouteNavigation();
    const { conditionFulfilled: isSmallDevice } = useWindowSizeMatch({
        condition: evaluators.lessThan(DEVICES_SIZES_IN_PX.medium),
    });
    const isUserEnabled = !!userInfo?.enabled;
    const homeRoute: RouteEnumType = isLoggedIn ? "homeRegistered" : "home";
    return (
        <nav className={`navbar navbar-expand-lg navbar-dark top-menu px-3${isLandingPage ? " top-menu_landing" : " bg-dark"}`}>
            <div className="container-fluid">
                <div className="d-flex">
                    <a href={getRoute(homeRoute)} onClick={(e) => navigateRouteClickHandler(homeRoute, e)}>
                        <img src={ASSETS_ROUTES.IMGS.logo} className="logo" alt="WinWinGo" title="WinWinGo" />
                    </a>
                </div>
                <div className="d-flex align-items-center gap-1 gap-sm-3">
                    {/* {isLoggedIn && <Notifications />}{" "} */}
                    {isSmallDevice.fulfilled && isLoggedIn && (
                        <>
                            {isUserEnabled && (
                                <div className="d-block d-lg-none">
                                    <MessagesNotifications isMobile={true} isLandingPage={isLandingPage} />
                                </div>
                            )}
                            <div className="d-block d-lg-none">
                                <NotificationsV2
                                    showForSmallDevice={true}
                                    isLandingPage={isLandingPage}
                                    refreshSuprSendUserToken={refreshSuprSendUserToken}
                                />
                            </div>
                        </>
                    )}{" "}
                    {isSmallDevice.fulfilled && (
                        <div className="">
                            <SupportBtn isLandingPage={isLandingPage} />
                        </div>
                    )}{" "}
                    <button
                        className="navbar-toggler rounded-3"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#navbarNavAltMarkup"
                        aria-controls="navbarNavAltMarkup"
                        aria-expanded="false"
                        aria-label="Toggle navigation"
                    >
                        <span className="navbar-toggler-icon fs-3"></span>
                    </button>
                </div>
                <div className="collapse navbar-collapse justify-content-end text-center" id="navbarNavAltMarkup">
                    <div className="navbar-nav">
                        {!isSmallDevice.fulfilled && <SupportBtn isLandingPage={isLandingPage} />}
                        <MyHomeLink />
                        <a className="nav-link nav-row rounded-3 ms-2" href={getRoute("aboutMark")}>
                            About
                        </a>
                        {userInfo?.type && isLoggedIn ? (
                            <>
                                <DashboardLink />
                                <MyAccountLink />
                                {isUserEnabled && !isSmallDevice.fulfilled && <MessagesNotifications isMobile={false} isLandingPage={isLandingPage} />}
                            </>
                        ) : (
                            <>
                                <a className="nav-link nav-row rounded-3 ms-2" href={getRoute("story")} onClick={(e) => navigateRouteClickHandler("story", e)}>
                                    Story
                                </a>
                                <a
                                    className="nav-link nav-row rounded-3 ms-2"
                                    href={getRoute("pricing")}
                                    onClick={(e) => navigateRouteClickHandler("pricing", e)}
                                >
                                    Pricing
                                </a>
                            </>
                        )}
                        {/*TODO:fix when know what to do with SuprSend and the notifications issue <div className="d-none d-lg-block ms-3"> */}
                        {/* OLD NOTIFICATION {isLoggedIn && <Notifications />}{" "} */}
                        {/* {!isSmallDevice.fulfilled && ( */}
                        {/* <NotificationsV2 */}
                        {/* showForSmallDevice={false} */}
                        {/* /> */}
                        {/* )}{" "} */}
                        {/* </div> */}
                        <SignInAndOut />
                    </div>
                </div>
            </div>
        </nav>
    );
};
